import { createSlice } from '@reduxjs/toolkit'

const defaultHistory = { visited: [], index: -1 }

const publication = createSlice({
  name: 'publication',
  initialState: {
    html: null,
    content: '',
    expandItemValues: [],
    history: defaultHistory
  },
  reducers: {
    SET: (state, { payload }) => ({ ...state, ...payload }),
    SET_EXPAND_ITEMS: (state, { payload }) => {
      state.expandItemValues = payload
    },
    SET_HISTORY: (state, { payload: { content, index } }) => {
      const { history } = state
      if (Number.isInteger(index)) history.index = index
      else if (content) {
        history.visited[++history.index] = content
        if (history.index !== (history.visited.length - 1)) history.visited = history.visited.slice(0, history.index + 1)
      }
    }
  }
})

export default publication

export const publicationActions = publication.actions

export const publicationSelectors = {
  selectPublication: state => state.publication
}
